import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Import Api files
import {
  addRequestApi,
  deleteRequestApi,
  editRequestApi,
  getRequestsApi,
  getSingleRequestApi,
} from "api/requests";

// Login Redux States
import {
  ADD_REQUEST,
  DELETE_REQUEST,
  EDIT_REQUEST,
  GET_REQUESTS,
  GET_SINGLE_REQUEST,
} from "./actionTypes";
import {
  addRequestFailure,
  addRequestSuccess,
  deleteRequestFailure,
  deleteRequestSuccess,
  editRequestFailure,
  editRequestSuccess,
  getRequestsFailure,
  getRequestsSuccess,
  getSingleRequestFailure,
  getSingleRequestSuccess,
} from "./actions";

function* getRequests() {
  try {
    const { data } = yield call(getRequestsApi);
    yield put(getRequestsSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getRequestsFailure(error?.response?.data?.errors?.[0]?.msg));
  }
}

function* getSingleRequest({ payload }) {
  try {
    const { data } = yield call(getSingleRequestApi, payload);
    yield put(getSingleRequestSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getSingleRequestFailure(error.response?.data?.message || error));
  }
}

function* addRequest({ payload }) {
  try {
    const { data } = yield call(addRequestApi, payload.data);
    yield put(addRequestSuccess(data));
    yield payload.navigate("/countries");
  } catch (error) {
    console.log(error);
    yield put(addRequestFailure(error.response?.data?.message || error));
  }
}

function* editRequest({ payload }) {
  try {
    yield call(editRequestApi, payload);
    yield put(editRequestSuccess(payload));
    yield payload.navigate("/countries");
  } catch (error) {
    console.log(error);
    yield put(editRequestFailure(error?.response?.data || error));
  }
}

function* deleteRequest({ payload }) {
  try {
    yield call(deleteRequestApi, payload);
    yield put(deleteRequestSuccess(payload));
  } catch (error) {
    console.log(error);
    yield put(deleteRequestFailure(error?.response?.data || error));
  }
}

export function* watchGetRequests() {
  yield takeEvery(GET_REQUESTS, getRequests);
}

export function* watchSingleRequest() {
  yield takeEvery(GET_SINGLE_REQUEST, getSingleRequest);
}

export function* watchAddRequest() {
  yield takeEvery(ADD_REQUEST, addRequest);
}

export function* watchEditRequest() {
  yield takeEvery(EDIT_REQUEST, editRequest);
}

export function* watchDeleteRequest() {
  yield takeEvery(DELETE_REQUEST, deleteRequest);
}

function* countriesSaga() {
  yield all([fork(watchGetRequests)]);
  yield all([fork(watchSingleRequest)]);
  yield all([fork(watchAddRequest)]);
  yield all([fork(watchEditRequest)]);
  yield all([fork(watchDeleteRequest)]);
}

export default countriesSaga;
